import { render, staticRenderFns } from "./petNetizen.vue?vue&type=template&id=fc67c8a6&scoped=true&"
import script from "./petNetizen.vue?vue&type=script&lang=js&"
export * from "./petNetizen.vue?vue&type=script&lang=js&"
import style0 from "./petNetizen.vue?vue&type=style&index=0&id=fc67c8a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc67c8a6",
  null
  
)

export default component.exports